module.exports = __webpack_public_path__ + "a7a8a87a76ee0877cecb1342d9184124.pdf";